module.exports = __webpack_public_path__ + "static/img/background.9a534a94.svg";